import React, { useState } from 'react';
import { DropdownButton } from 'react-bootstrap';

import { getListOfTask } from './view_detail_logic';

export const ViewDetailSelect = (props) => {
  const [taskDetails, setTaskDetails] = useState([]);

  const getTasks = async () => {
    await getListOfTask(props, setTaskDetails);
  };

  return (
    <DropdownButton
      id="dropdown-basic-button"
      title="Ver Detalle"
      variant={'secondary'}
      onClick={() => getTasks()}
    >
      {taskDetails}
    </DropdownButton>
  );
};

export default ViewDetailSelect;
